<div class="panel panel-default" *ngIf="loaded">
    <div class="panel-heading">
        <b [innerHtml]="title"></b>
    </div>
    <div class="panel-body">
        <span [innerHtml]="text"></span>
    </div>
</div>
